import '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import 'react';
import 'reakit-utils/useForkRef';
import 'reakit-utils/isButton';
import 'reakit-warning';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/useIsomorphicEffect';
import 'reakit-utils/hasFocusWithin';
import 'reakit-utils/isPortalEvent';
import 'reakit-utils/getActiveElement';
import 'reakit-utils/canUseDOM';
import 'reakit-utils/tabbable';
import '../Role/Role.js';
import { useTabbable } from '../Tabbable/Tabbable.js';

// Automatically generated
var INPUT_KEYS = [];

var useInput = createHook({
  name: "Input",
  compose: useTabbable,
  keys: INPUT_KEYS
});
var Input = createComponent({
  as: "input",
  memo: true,
  useHook: useInput
});

export { Input, useInput };
